import { Card, Divider, IconButton, Link, Typography, useTheme } from "@mui/material";
import { Seminario } from "../../services/api/seminarios";
import { Delete, Edit } from "@mui/icons-material";
import { EventoBarragem } from "../../services/api/company";
import { useApi } from "../../services";
import { useEffect, useState } from "react";
import { BarragemData, useUserContext } from "../../context";

export const CardSeminario: React.FC<{
  onEdit?: (evento: EventoBarragem) => void;
  onRemove?: (seminario: Seminario) => void;
  seminario: Seminario;
  seminarioAnterior?: Seminario;
}> = ({ seminario, seminarioAnterior, onRemove, onEdit }) => {
  const { palette } = useTheme();
  const api = useApi();
  const user = useUserContext();

  const [barragem, setBarragem] = useState<BarragemData>();

  // Obtendo dados da barragem do simulado
  useEffect(() => {
    api.barragem.getBarragemById(seminario.idBarragem).then(value => {
      if ('error' in value) return;
      setBarragem(value);
    });
  }, [seminario]);

  const handleClick = () => {
    if (seminario.file) window.open(seminario.file, '_blank');
  };

  if (!user || "error" in user) return <Typography fontWeight={700} fontSize={18}>Sem Usuário</Typography>;

  return <Card sx={{
    padding: 2,
    gap: "5px",
    width: "18em",
    display: "flex",
    flexDirection: "column",
    bgcolor: palette.calendario.seminarioCardColor,
  }}>
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <Typography fontWeight={700} fontSize={18}>{`Seminário Orientativo${barragem?.nome ? ` em ${barragem.nome}` : ""}`}</Typography>
      <div style={{ flex: 1 }} />
      {user.admin && onEdit && <IconButton onClick={() => onEdit({ tipo: "seminario", evento: seminario })} size="small">
        <Edit fontSize="small" />
      </IconButton>
      }
      {user.admin && onRemove &&
        <IconButton onClick={() => onRemove(seminario)} size="small">
          <Delete fontSize="small" />
        </IconButton>
      }
    </div>
    <Divider />
    <Item title="Horário de Início" value={seminario.data.getHours().toSignificantDigits('horaData') + ":" + seminario.data.getHours().toSignificantDigits('minutoData')} />
    <Item title="Local" value={seminario.local} />
    <Item title="Responsável" value={seminario.responsavel} />
    <Item title="Participantes Estimados" value={(seminario.participantes ?? 0).toString()} />
    {seminarioAnterior && <Item title="Data do último seminário" value={seminarioAnterior.data.getDate().toSignificantDigits('dia') + "/" + (seminarioAnterior.data.getMonth() + 1).toSignificantDigits('mes') + "/" + seminarioAnterior.data.getFullYear().toString()} />}

    {/* Arquivo */}
    <div style={{ display: "flex", flexDirection: "row" }}>
      <Typography fontWeight={700} fontSize={14}>
        •&nbsp;Arquivo:&nbsp;
      </Typography>
      {
        seminario.file ?
          <Link onClick={handleClick}>acesse aqui</Link> :
          <Typography fontSize={14}>nenhum arquivo</Typography>
      }
    </div>

    {/* Observações por último */}
    {seminario.obs && <Item title="Observações" value={seminario.obs} />}

  </Card>;

};

const Item = ({ title, value }: { title: string; value: string; }) => {
  return <div style={{ display: "flex", flexDirection: "row" }}>
    <Typography fontWeight={700} fontSize={14}>
      •&nbsp;{title}:&nbsp;
    </Typography>
    <Typography fontSize={14}>
      {value}
    </Typography>
  </div>;
};

